import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import API_BASE from "../config/api";
import Swal from "sweetalert2";


function Register() {
    const [form, setForm] = useState({
        fullname: "",
        mobile: "",
        email: "",
        password: "",
        confirmPassword: "",
    });

    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validate = () => {
        if (!form.fullname) return "Name required";
        if (!/^[6-9]\d{9}$/.test(form.mobile)) return "Invalid mobile";
        if (!/\S+@\S+\.\S+/.test(form.email)) return "Invalid email";
        if (form.password.length < 6) return "Password too short";
        if (form.password !== form.confirmPassword) return "Passwords do not match";
        return null;
    };
    const showToast = (message, icon) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            icon: icon,
            title: message,
            showConfirmButton: false,
            timer: 1000,
            customClass: {
                popup:
                    icon === "success"
                        ? "my-toast my-toast-success"
                        : icon === "error"
                            ? "my-toast my-toast-error"
                            : "my-toast my-toast-warning",
            },
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const error = validate();
        if (error) {
            showToast(error, "warning");   // ⬅ replaced Swal.fire
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/api/manual_register.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const data = await res.json();
            setLoading(false);

            if (data.success) {
                showToast(data.message, "success");   // ⬅ replaced Swal.fire

                setForm({
                    fullname: "",
                    mobile: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                });

                setTimeout(() => {
                    window.location.href = "/login";
                }, 1500);
            } else {
                showToast(data.message, "error");     // ⬅ replaced Swal.fire
            }
        } catch (err) {
            setLoading(false);
            showToast("Server Error, Please try again.", "error"); // ⬅ replaced Swal.fire
        }
    };



    const handleGoogle = async (cred) => {
        try {
            const res = await axios.post(`${API_BASE}/api/google_register.php`, {
                token: cred.credential,
            });

            if (res.data.success) {
                showToast("Google login successful", "success"); // ⬅ replaced Swal.fire

                setTimeout(() => {
                    window.location.href = "/";
                }, 1500);
            } else {
                showToast(res.data.message, "error"); // ⬅ replaced Swal.fire
            }
        } catch (err) {
            showToast("Google login failed", "error"); // ⬅ replaced Swal.fire
        }
    };


    return (
        <>

            <div className="container py-5 d-flex justify-content-center">
                <div
                    className="p-5 shadow-lg rounded-4 bg-white"
                    style={{ maxWidth: "500px", width: "100%", borderTop: "5px solid #1E49FF" }}
                >
                    <div className="text-center mb-4">
                        <img src="/logo.png" alt="Logo" style={{ width: "120px" }} />
                    </div>

                    <h2 className="text-center fw-bold mb-4" style={{ color: "#1E49FF" }}>
                        Create Your Account
                    </h2>

                    {msg && <div className="alert alert-info text-center">{msg}</div>}

                    {/* Google Login */}
                    <div className="d-flex justify-content-center mb-3">
                        <GoogleLogin
                            onSuccess={handleGoogle}
                            onError={() => setMsg("Google Login Failed")}
                        />
                    </div>

                    <p className="text-center text-muted mb-4">OR REGISTER WITH EMAIL</p>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Full Name</label>
                            <input
                                name="fullname"
                                className="form-control border-2 border-primary rounded-pill shadow-sm"
                                value={form.fullname}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Mobile Number</label>
                            <input
                                name="mobile"
                                className="form-control border-2 border-primary rounded-pill shadow-sm"
                                value={form.mobile}
                                onChange={handleChange}
                                placeholder="10-digit number"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Email</label>
                            <input
                                name="email"
                                className="form-control border-2 border-primary rounded-pill shadow-sm"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="Enter email"
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Password</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control border-2 border-primary rounded-pill shadow-sm"
                                value={form.password}
                                onChange={handleChange}
                                placeholder="Create password"
                            />
                        </div>

                        <div className="mb-4">
                            <label className="form-label fw-semibold">Confirm Password</label>
                            <input
                                type="password"
                                name="confirmPassword"
                                className="form-control border-2 border-primary rounded-pill shadow-sm"
                                value={form.confirmPassword}
                                onChange={handleChange}
                                placeholder="Re-enter password"
                            />
                        </div>

                        <button
                            type="submit"
                            className="btn w-100 py-2 fw-bold text-white"
                            style={{
                                background: "linear-gradient(90deg, #1E49FF, #08f7fe)",
                                borderRadius: "50px",
                                fontSize: "16px",
                            }}
                        >
                            {loading ? "Creating..." : "Create Account"}
                        </button>

                        <p className="text-center mt-3">
                            Already have an account?{" "}
                            <a href="/login" className="fw-bold text-primary">
                                Login
                            </a>
                        </p>

                        <p className="text-center mt-2">
                            <a href="/" className="fw-bold text-secondary">
                                Back to Home
                            </a>
                        </p>
                    </form>
                </div>
                {/* SMALL TOAST CSS */}
                <style>{`
                .small-swal {
                    padding: 6px 12px !important;
                    font-size: 14px !important;
                    border-radius: 6px !important;
                    min-height: 40px !important;
                }
                    .my-toast {
                    padding: 10px 16px !important;
                    font-size: 15px !important;
                    border-radius: 8px !important;
                    min-height: 45px !important;
                    box-shadow: 0px 3px 10px rgba(0,0,0,0.15) !important;
                }

                .my-toast-success {
                    background: #d4f8d4 !important;
                    border-left: 5px solid #28a745 !important;
                    color: #155724 !important;
                }

                .my-toast-error {
                    background: #fde2e2 !important;
                    border-left: 5px solid #dc3545 !important;
                    color: #721c24 !important;
                }

                .my-toast-warning {
                    background: #fff3cd !important;
                    border-left: 5px solid #ff9800 !important;
                    color: #7a5200 !important;
                }

                            `}</style>
            </div>

        </>
    );
}

export default Register;
